
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'CashoutDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    cashoutValue: {
      type: String,
      required: true
    },
    potentialWin: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    t(key: string): string {
      return this.$t(key) as string;
    }
  }
});
